import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale } from 'chart.js';
import * as R from 'ramda';
import ChartsMixin from '@/mixins/ChartsMixin.vue';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { DashedLinesToAxis, htmlLegendPlugin } from "@/utils/dashboard/charts_plugins.js";
ChartJS.register(Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale, ChartDataLabels, DashedLinesToAxis, htmlLegendPlugin);
export default {
  name: 'BarChart',
  components: {
    Bar
  },
  mixins: [ChartsMixin],
  props: {
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    x2Label: {
      type: String,
      default: ''
    },
    metricColor: {
      type: String
    },
    showEvolution: {
      type: Boolean
    }
  },
  data() {
    return {
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          htmlLegend: {
            containerID: 'chart-indicators'
          },
          tooltip: {
            titleFont: {
              family: 'Figtree, sans-serif'
            },
            bodyFont: {
              family: 'Figtree, sans-serif'
            }
          }
        },
        scales: {
          x: {
            ticks: {
              font: {
                family: 'Figtree, sans-serif',
                size: 12
              }
            },
            grid: {
              display: false,
              drawBorder: false
            }
          },
          y: {
            grid: {
              drawBorder: false
            }
          }
        }
      }
    };
  },
  computed: {
    mergedOptions() {
      return R.mergeDeepRight(this.defaultOptions, this.options || {});
    }
  }
};